module.exports = __webpack_public_path__ + "static/shireesha-b12d340bbf6ea7806db06416df873669.png";